import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { showToast } from "../../../utils/general";
import { Tooltip } from "../Tooltip";

const UploadButton = ({
  title,
  handler,
  acceptedFileTypes = "image/png, image/jpeg, image/jpg",
  isCustomUpload,
  disabled,
  tooltipMessage,
}) => {
  console.log("disabledButton", disabled);
  const dispatch = useDispatch();
  const appState = useSelector((state) => state.appState);
  // Function to handle file selection
  const handleFileSelect = (event) => {
    if (isCustomUpload) {
      return handler();
    }
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = acceptedFileTypes; // Specify allowed file types
    fileInput.style.display = "none";

    // Trigger a click event on the file input when the button is clicked
    fileInput.addEventListener("change", () => {
      const selectedFile = fileInput.files[0];
      if (selectedFile) {
        if (selectedFile.type.includes("video")) {
          if (selectedFile.size > 50 * 1024 * 1024) {
            showToast("Max size: 50 MB.", "", "danger");
            return;
          }
        }
        dispatch(handler(selectedFile)); // Call the handler with the selected file
      }
    });

    document.body.appendChild(fileInput);
    fileInput.click();

    // Clean up the file input element
    fileInput.remove();
  };

  return (
    <div className="absolute bottom-0 left-0 right-0 flex items-center justify-start px-4 py-2 ">
      <div className="relative group w-full">
        <button
          className="bg-gray-600 text-white hover:bg-black text-xs font-bold p-2 rounded items-center w-full"
          onClick={handleFileSelect}
          disabled={disabled}
        >
          {appState === "imageUploading" ? (
            <span className="loader-small"></span>
          ) : (
            title
          )}
        </button>
        {!!tooltipMessage && (
          <Tooltip className={"bottom-[100%] w-[800px] text-sm"}>
            {tooltipMessage}
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default UploadButton;
